import { FetchRequest } from '@rails/request.js'

interface CloseArgs {
  id: string
}

export function close({ id }: CloseArgs) {
  const endpoint = `/close_system_notifications/${id}`

  return new FetchRequest('put', endpoint).perform()
}
